import { inject as service } from '@ember/service';
import Route from 'cio/routes/base';
import DS from 'ember-data';

export default class SmtpRoute extends Route {
  @service store!: DS.Store;

  crumb() {
    return {
      name: 'Custom SMTP Settings',
      path: 'actions.email.smtp',
    };
  }

  model() {
    return this.store.findAll('mail-server');
  }
}
